export default __webpack_public_path__ + "static/media/graph-01.09670977.svg";